import React from 'react'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import VpnKeyIcon from '@mui/icons-material/VpnKey'
import { IconButton, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  actionItem: {
    color: theme.palette.info.dark,
    '&:hover': {
      border: 0,
      color: theme.palette.info.main,
    },
  },
}))

interface IActionItemData {
  icon: string
  tooltip?: string
  onClick?: () => void
}

const ActionItem: React.FC<IActionItemData> = (props) => {
  const classes = useStyles()

  return (
    <IconButton className={classes.actionItem} size='small' onClick={() => props.onClick && props.onClick()}>
      {props.icon === 'edit' ? <EditIcon /> : props.icon === 'key' ? <VpnKeyIcon /> : <DeleteIcon />}
    </IconButton>
  )
}
export default ActionItem
